module.exports = __webpack_public_path__ + "static/media/S3N9-5.ff874f30.svg";